/**
 * @param {string[]} components - array of location components
 * @returns a formatted locationString
 */
export default function (components) {
  return components.filter((str) => !!str && str !== '-').join(', ');
}
